import { HFlow, Text } from 'bold-ui'
import { SimNaoRadioGroupField } from 'components/form'
import { RequiredLabel } from 'components/form/core/RequiredLabel/RequiredLabel'
import { ReactNode } from 'react'
import { Meta, MetaArray } from 'util/metaPath'

interface FormRowSimNaoProps {
  name: string | MetaArray<any> | Meta<any>
  title: string
  required?: boolean
  clearable?: boolean
  disabled?: boolean
  children?: ReactNode
}

export const FormRowSimNao = ({
  name,
  title,
  required = false,
  clearable = false,
  disabled = false,
  children,
}: FormRowSimNaoProps) => {
  return (
    <HFlow>
      {required ? <RequiredLabel fontWeight='bold' label={title} /> : <Text fontWeight='bold'>{title}</Text>}

      <HFlow alignItems='center'>
        <SimNaoRadioGroupField name={name} globalClearable={clearable} disabled={disabled} />
        {children}
      </HFlow>
    </HFlow>
  )
}
